var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44939_319719)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44939_319719)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44939_319719",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 .064H0V24h31V.064z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44939_319719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 0H0v24h31V0z",
    fill: "#0D5EAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.889 8v5.333H31V16H0v-2.667h4.593V8H0V5.333h4.593V0h2.296v5.333h4.593V8H6.889zm4.593-5.333H31v2.666H11.482V2.667zm0 5.333H31v2.667H11.482V8zM31 21.333H0v-2.666h31v2.666z",
    fill: "#fff"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44939_319719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44939_319719"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h31v24H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreek);
export default __webpack_public_path__ + "static/media/greek.41e7ef0e7edefd8fe946465e2d0a432d.svg";
export { ForwardRef as ReactComponent };